const actions = {
    sendUserMessage({commit}, payload) {
        this.http.postMessage(payload);
    },
    sendAgentMessage({commit}, payload) {
        /*
        commit('actionMessage', {
            sender: false,
            text: payload
        });*/
    },
    closeCurrentChat() {
        this.http.closeThread().then(
            (apayload) => {
                this.commit('changeChatWindowStatus', 1)
            }
        );
    },
    sendOfflineMessage({commit}, payload) {
        this.http.sendOfflineMessage(payload.message).then((response) => {
            if (payload.callback){
                payload.callback(response);
            }
        });
    },
    shareCartWithAgent({commit}, payload) {
        this.http.shareUrlWithAgent(payload.share_url);
    }
}
export default actions